export default __webpack_public_path__ + "static/media/char_head_007.96ff20b7.png";